export class RunningAverage {
  private _avg: number = 0;
  private _count: number = 0;

  public addValue(value: number): void {
    this._count++;
    this._avg += (value - this._avg) / this._count;
  }

  public reset(): number {
    const avgCache: number = this._avg;
    this._avg = 0;
    this._count = 0;

    return avgCache;
  }

  get avg(): number {
    return this._avg;
  }
}
